/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";

// import { Table } from "antd";
import { Table } from "ant-table-extensions";
import "antd/dist/antd.css";
import { RotatingLines } from "react-loader-spinner";
import Button from "@mui/material/Button";
import axios from "axios";
import {
  itemRender,
  onShowSizeChange,
} from "../../../../components/paginationfunction";
//import "./antdstyle.css";
import Select from "react-select";
import eye from "../../../../assets/img/profiles/Group813.png";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import FilterOff from "../../../../assets/img/profiles/filter-off-fill1.svg";


const OverViewTable = () => {
  const [toggle, setToggle] = useState(0);
  const [name1, setName1] = useState("");
  const [location, setLocation] = useState("");
  const [empCode, setEmpCode] = useState("");
  const [address1, setAddress1] = useState("");
  const [designation1, setDesignation1] = useState("");
  const [empPayrollDetails, setEmpPayrollDetails] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [empID, setEmpID] = useState("");
  const [empName, setEmpName] = useState("");
  const [col, setCol] = useState([]);


  const rolePermissions = JSON.parse(sessionStorage.getItem("permissions"));



  console.log(col);

  const token = sessionStorage.getItem("access_token");

  const handleGetPayroll = () => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/payroll/`, {
        params: {
          empl_id: sessionStorage.getItem("emp_id"),
          toggle: "t",
          comp_id: sessionStorage.getItem("coid"),
        },
      })
      .then((res) => {
        //console.log(res.data);
        setCol(
          res.data.columns.map((ele) => {
            if (ele.key === "employee_name") {
              return {
                title: ele.name.replace(".", ""),
                width: 200,
                dataIndex: ele.key.replace(".", ""),
                key: ele.key.replace(".", ""),
                align: "left",
                fixed: "left",
              };
            } else if (ele.key.replace(".", "") === "employee_id") {
              return {
                title: ele.name.replace(".", ""),
                width: 100,
                dataIndex: ele.key.replace(".", ""),
                key: ele.key.replace(".", ""),
                align: "left",
                fixed: "left",
              };
            } else {
              return {
                title: ele.name.replace(".", ""),
                width: 180,
                dataIndex: ele.key.replace(".", ""),
                key: ele.key.replace(".", ""),
                // align: "right",
              };
            }
            // title: ele.name.replace(".", ""),
            // dataIndex: ele.key.replace(".", ""),

            // align: "right",
          })
        );
        setEmpPayrollDetails(res.data.data);
        setSearchData(res.data.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    handleGetPayroll();
  }, []);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/directory/`, {
        params: {
          empid: sessionStorage.getItem("emp_id"),
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        // setEmpPayrollDetails(res.data);
        // setSearchData(res.data);
        // console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);






  const handleSearch1 = () => {
    const newData = empPayrollDetails
      .filter((x) => x.employee_name === (name1 === "" ? x.employee_name : name1))
      .filter((y) => y.department === (address1 === "" ? y.department : address1))
      .filter((y) => y.emp_code === (empCode === "" ? y.emp_code : empCode))
      .filter(
        (y) =>
          y.office_location === (location === "" ? y.office_location : location)
      )
      .filter(
        (z) =>
          z.employement_type ===
          (designation1 === "" ? z.employement_type : designation1)
      );
    setSearchData(newData);
  };


  useEffect(() => {
    handleSearch1();
  }, [name1, address1, designation1, location, empCode]);

  const columns = [
    // {
    //   title: "Employee ID",
    //   dataIndex: "emp_id",
    //   sorter: (a, b) => a.emp_id.length - b.emp_id.length,
    // },
    // {
    //   title: "Employee Name",
    //   dataIndex: "emp_name",
    //   sorter: (a, b) => a.joindate.length - b.joindate.length,
    // },
    // {
    //   title: "Department",
    //   dataIndex: "emp_dept",
    //   sorter: (a, b) => a.mobile.length - b.mobile.length,
    // },
    // {
    //   title: "Designation",
    //   dataIndex: "emp_desg",
    //   sorter: (a, b) => a.mobile.length - b.mobile.length,
    // },
    // {
    //   title: "Employment Type",
    //   dataIndex: "emp_type",
    // },
    // {
    //   title: "Email",
    //   dataIndex: "emp_email",
    //   sorter: (a, b) => a.email.length - b.email.length,
    // },
    // {
    //   title: "CTC",
    //   dataIndex: "ctc",
    //   sorter: (a, b) => a.email.length - b.email.length,
    //   render: (text, record) => Math.round(text),
    // },
    {
      title: "Action",
      align: "center",
      fixed: "right",
      render: (text, record) => (
        <div className="dropdown dropdown-action ">
          <div
            href="#"
            className="action-icon dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            disabled={
              rolePermissions["Overview Payroll"] === "Edit/Create/Approve"
                ? false
                : true
            }
          >
            <Button variant="contained">
              <MoreHorizIcon />
            </Button>
          </div>
          <div
            className="dropdown-menu dropdown-menu-right"
            style={{ inset: "-100px auto auto 0px" }}
          >
            <div
              className="dropdown-item"
              href="#"
              onClick={() => {
                setToggle(1);
                setEmpID(text.employee_id);
                setEmpName(text.employee_name);
              }}
            >
              <img
                src={eye}
                style={{
                  height: "10px",
                  width: "15px",
                }}
                alt=""
              />
              <b> View Salary Breakup</b>
            </div>
            <div
              className="dropdown-item"
              href="#"
              onClick={() => {
                setToggle(2);
                setEmpID(text.employee_id);
                setEmpName(text.employee_name);
              }}
            >
              <i className="fa fa-pencil m-r-5" />
              <b> Revise Salary</b>
            </div>
            {/* <a
              className="dropdown-item"
              href="#"
              data-bs-toggle="modal"
              data-bs-target="#delete_employee"
            >
              <i className="fa fa-trash-o m-r-5" />
              <b> Skip Payroll</b>
            </a> */}
          </div>
        </div>
      ),
    },
  ];





  return (
    <div >
   

          {isLoading ? (
            <div style={{ marginLeft: "45%", marginTop: "15%" }}>
              <RotatingLines
                strokeColor="white"
                strokeWidth="5"
                animationDuration="0.50"
                width="50"
                marginRight="700"
                visible={true}
              />
            </div>
          ) : (
            <>
              {" "}
              {toggle === 0 && (
                <>
                  <div className="row filter-row">
                    <div className="col-sm-6 col-md-2">
                      <div className="form-group form-focus select-focus">
                        <Select
                          inputId="single-select-example"
                          isClearable
                          className="single-select"
                          classNamePrefix="react-select"
                          placeholder="Employee Name"
                          options={[
                            ...new Set(
                              empPayrollDetails?.map(
                                (item) => item.employee_name
                              )
                            ),
                          ].map((ele) => ({
                            label: ele,
                            value: ele,
                          }))}
                          value={
                            name1 !== ""
                              ? {
                                  label: name1,
                                  value: name1,
                                }
                              : null
                          }
                          onChange={(e) => setName1(e ? e.value : "")}
                          styles={{
                            // Fixes the overlapping problem of the component
                            menu: (provided) => ({ ...provided, zIndex: 9999 }),
                          }}
                          style={{
                            height: "50px",
                            width: "100%",
                            border: "1px solid lightgrey",
                            borderRadius: "3px",
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 col-md-2">
                      <div className="form-group form-focus select-focus">
                        <Select
                          inputId="single-select-example"
                          isClearable
                          className="single-select"
                          classNamePrefix="react-select"
                          placeholder="Employee Code"
                          options={[
                            ...new Set(
                              empPayrollDetails?.map((item) => item.emp_code)
                            ),
                          ].map((ele) => ({
                            label: ele,
                            value: ele,
                          }))}
                          value={
                            empCode !== ""
                              ? {
                                  label: empCode,
                                  value: empCode,
                                }
                              : null
                          }
                          onChange={(e) => setEmpCode(e ? e.value : "")}
                          styles={{
                            // Fixes the overlapping problem of the component
                            menu: (provided) => ({ ...provided, zIndex: 9999 }),
                          }}
                          style={{
                            height: "50px",
                            width: "100%",
                            border: "1px solid lightgrey",
                            borderRadius: "3px",
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 col-md-2">
                      <div className="form-group form-focus select-focus">
                        <Select
                          placeholder="Employment Type"
                          isClearable
                          options={[
                            ...new Set(
                              empPayrollDetails?.map(
                                (item) => item.employement_type
                              )
                            ),
                          ].map((ele) => ({
                            label: ele,
                            value: ele,
                          }))}
                          value={
                            designation1 !== ""
                              ? {
                                  label: designation1,
                                  value: designation1,
                                }
                              : null
                          }
                          onChange={(e) => {
                            setDesignation1(e ? e.value : "");
                          }}
                          styles={{
                            // Fixes the overlapping problem of the component
                            menu: (provided) => ({ ...provided, zIndex: 9999 }),
                          }}
                          //className="select floating"
                          style={{
                            height: "50px",
                            width: "100%",
                            border: "1px solid lightgrey",
                            borderRadius: "3px",
                          }}
                        />
                        {/* <label className="focus-label">Designation</label> */}
                      </div>
                    </div>
                    <div className="col-sm-6 col-md-2">
                      <div className="form-group">
                        <Select
                          // type="text"
                          // className="form-control input-height"
                          isClearable
                          options={[
                            ...new Set(
                              empPayrollDetails?.map((item) => item.department)
                            ),
                          ].map((ele) => ({
                            label: ele,
                            value: ele,
                          }))}
                          value={
                            address1 !== ""
                              ? {
                                  label: address1,
                                  value: address1,
                                }
                              : null
                          }
                          onChange={(e) => {
                            setAddress1(e ? e.value : "");
                          }}
                          placeholder="Department"
                          styles={{
                            // Fixes the overlapping problem of the component
                            menu: (provided) => ({ ...provided, zIndex: 9999 }),
                          }}
                          style={{
                            height: "50px",
                            width: "100%",
                            border: "1px solid lightgrey",
                            borderRadius: "3px",
                          }}
                          //   onChange={(e) =>
                          //     setAddress1(e.target.value.toLocaleLowerCase())
                          //   }
                        />
                        {/* <label className="focus-label">Location</label> */}
                      </div>
                    </div>
                    <div className="col-sm-6 col-md-2">
                      <div className="form-group">
                        <Select
                          // type="text"
                          // className="form-control input-height"
                          isClearable
                          options={[
                            ...new Set(
                              empPayrollDetails?.map(
                                (item) => item.office_location
                              )
                            ),
                          ].map((ele) => ({
                            label: ele,
                            value: ele,
                          }))}
                          value={
                            location !== ""
                              ? {
                                  label: location,
                                  value: location,
                                }
                              : null
                          }
                          onChange={(e) => {
                            setLocation(e ? e.value : "");
                          }}
                          placeholder="Location"
                          styles={{
                            // Fixes the overlapping problem of the component
                            menu: (provided) => ({ ...provided, zIndex: 9999 }),
                          }}
                          style={{
                            height: "50px",
                            width: "100%",
                            border: "1px solid lightgrey",
                            borderRadius: "3px",
                          }}
                          //   onChange={(e) =>
                          //     setAddress1(e.target.value.toLocaleLowerCase())
                          //   }
                        />
                        {/* <label className="focus-label">Location</label> */}
                      </div>
                    </div>
                    <div className="row col-sm-6 col-md-2">
                

                      <div className="col-md-3">
                        <div
                          className="btn-block "
                          onClick={() => (
                            setAddress1(""),
                            setDesignation1(""),
                            setName1(""),
                            setEmpCode(""),
                            setLocation("")
                          )}
                          href="#"
                        >
                          <img
                            tabindex="0"
                            data-bs-toggle="tooltip"
                            title="clear all filter"
                            style={{
                              height: "38px",
                              backgroundColor: "#3298DB",
                              padding: "7px 5px",
                              borderRadius: "5px",
                            }}
                            src={FilterOff}
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
         
                  </div>

                
                    <div className="card mb-0">
                      <div className="card-body">
                        <div className="table-responsive">
                          <Table
                            searchable
                            exportableProps={{ showColumnPicker: true }}
                            className="table-striped"
                            style={{ overflowX: "auto" }}
                            columns={col.concat(columns)}
                            // bordered
                            dataSource={searchData}
                            rowKey={(record) => record.id}
                            pagination={{
                              total: searchData.length,
                              showTotal: (total, range) =>
                                `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                              showSizeChanger: true,
                              position: ["bottomRight"],
                              onShowSizeChange: onShowSizeChange,
                              itemRender: itemRender,
                            }}
                            scroll={{ x: 1300 }}
                          />
                        </div>
                      </div>
                    </div>
                
    
                </>
              )}
     
            </>
          )}
    </div>
  );
};

export default OverViewTable;
